/**
 * ReportBlock
 * @module components/ReportBlock
 */

import { ImageModel } from 'types/common';
import Button from 'components/ui/Button';
import Icon from 'components/ui/Icon';
import clsx from 'clsx';
import { useSiteType } from 'context/siteType.context';

interface ReportBlockModel {
	modelType: string;
	heading: string;
	date: string;
	name: string;
	linkToPdf: string;
	image: ImageModel;
	buttonText: string;
	buttonLink: string;
}

const ReportBlock = ({
	heading,
	date,
	name,
	linkToPdf,
	image,
	buttonText,
	buttonLink,
}: ReportBlockModel) => {
	const siteType = useSiteType();
	return (
		<div className="flex pr-10">
			{image && (
				<div className="h-45 min-h-45 w-35 min-w-35 lg:w-45 lg:min-w-45 lg:h-62.5 lg:min-h-62.5">
					<img
						src={image.src}
						alt={image.alt}
						className="image__object-fit w-full h-full"
					/>
				</div>
			)}
			{heading && (
				<div className="ml-6">
					{date && (
						<p
							className={clsx(
								'mb-2  font-light text-p',
								siteType === 'LindabGroup'
									? 'text-lgDarkGray font-semibold'
									: 'text-greyDarkest'
							)}
						>
							{date}
						</p>
					)}
					<h2
						className={clsx(
							'text-h2 text-black mb-2 font-medium',
							siteType === 'LindabGroup' ? 'text-lgDarkBlue' : 'text-blue'
						)}
					>
						{heading}
					</h2>
					{name && (
						<a
							href={linkToPdf}
							target="_blank"
							className={clsx(
								'block text-h4  hover:underline lg:mb-8',
								siteType === 'LindabGroup' ? 'text-lgDarkBlue' : 'text-blue'
							)}
						>
							<span>
								<Icon icon="file" size={1.25} className="mr-2 -mt-1" />
							</span>
							{name}
						</a>
					)}
					{buttonLink && (
						<Button
							buttonColor={siteType === 'LindabGroup' ? 'lgYellow' : 'blue'}
							type="link"
							url={buttonLink}
						>
							{buttonText}
						</Button>
					)}
				</div>
			)}
		</div>
	);
};

export default ReportBlock;
